import styled from "@emotion/styled";
import { Button } from "../../../../../StyledComponents";

export const SettingsFormRow = styled.div(`
  width: 100%;
  min-width: 0;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
  padding: 1rem 1rem 2.2rem;
`)

export const SettingsSaveControl = styled.div(`
  width: fit-content;
  min-width: 0;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  align-self: flex-end;
  padding-bottom: 0.15rem;
`)

export const SettingsActionButton = styled(Button)(({ theme }) => `
  && {
    width: 9.75rem;
    min-width: 9.75rem;
    height: 3rem;
    margin: 0;
    border-radius: 0.85rem;
    font-size: 1rem;
    font-weight: 800;
    letter-spacing: 0;
    text-transform: capitalize;
    transition: border-color 0.16s ease, background 0.16s ease, box-shadow 0.16s ease, transform 0.16s ease;
  }

  &&.primary {
    color: ${theme.palette.common.white};
    border: 0.1rem solid rgba(13, 128, 63, 0.72);
    background: linear-gradient(180deg, #25a94a 0%, #15933a 100%);
    box-shadow: 0 0.45rem 0.95rem rgba(20, 133, 65, 0.18), inset 0 0.08rem 0 rgba(255, 255, 255, 0.28);
  }

  &&.primary:hover {
    color: ${theme.palette.common.white};
    border-color: rgba(8, 113, 54, 0.9);
    background: linear-gradient(180deg, #209d44 0%, #0f8132 100%);
    box-shadow: 0 0.55rem 1.05rem rgba(20, 133, 65, 0.24), inset 0 0.08rem 0 rgba(255, 255, 255, 0.22);
    transform: translateY(-0.04rem);
  }

  &&.primary:active {
    background: linear-gradient(180deg, #0f8132 0%, #0d7130 100%);
    box-shadow: 0 0.25rem 0.55rem rgba(20, 133, 65, 0.18), inset 0 0.12rem 0.25rem rgba(12, 57, 28, 0.18);
    transform: translateY(0);
  }

  &&.primary:focus-visible,
  &&.primaryLoading:focus-visible {
    outline: 0.18rem solid rgba(37, 169, 74, 0.24);
    outline-offset: 0.15rem;
  }

  &&.primaryDisabled {
    color: #7a8790;
    border: 0.1rem solid ${theme.palette.common.grayBorder};
    background: linear-gradient(180deg, #f6f8fb 0%, #e8edf3 100%);
    box-shadow: inset 0 0.08rem 0 rgba(255, 255, 255, 0.72);
    cursor: not-allowed;
  }

  &&.primaryDisabled:hover,
  &&.primaryDisabled:active {
    color: #7a8790;
    border-color: ${theme.palette.common.grayBorder};
    background: linear-gradient(180deg, #f6f8fb 0%, #e8edf3 100%);
    box-shadow: inset 0 0.08rem 0 rgba(255, 255, 255, 0.72);
    cursor: not-allowed;
    transform: none;
  }

  &&.primaryDisabled:focus-visible {
    outline: 0.18rem solid rgba(122, 135, 144, 0.16);
    outline-offset: 0.15rem;
  }

  &&.primaryLoading {
    color: ${theme.button.text.primaryLoading};
    border: 0.1rem solid rgba(13, 128, 63, 0.72);
    background: linear-gradient(180deg, #1b9840 0%, #157f36 100%);
    box-shadow: inset 0 0.08rem 0 rgba(255, 255, 255, 0.2);
    cursor: wait;
  }
`)
